const format = (str: string) => {
  let r = str.replace(/[^\d]+/gi, '');
  r = r.slice(0, 9);
  if (r.length > 5) {
    const parts = r.split('');
    parts.splice(5, 0, '-');
    return parts.join('');
  }
  return r;
};

export default {
  accept: /\d+/g,
  format,
};
